import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import axios from 'axios'
import {useNavigate} from 'react-router-dom'
import {MultiSelect} from 'primereact/multiselect'
import Swal from 'sweetalert2'
import AsyncSelect from 'react-select/async'
import makeAnimated from 'react-select/animated'
import InputMask from 'react-input-mask'
import {colourStyles} from '../../../components/styles/styles'
import {IProperties, propertiesInitValues as initialValues} from '../../../models/PropertiesModel'
import {Properties} from '../../../components/property-list/core/_models'
import {IndemnityItemPage} from '../../../../indemnityArea'
import {Input3} from '../../../../../../../components/Forms/Input'
import {PropertiesParticipationsList} from '../../../../propertyParticipations/PropertiesParticipationsList'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

const API_URL = process.env.REACT_APP_API_URL || 'api'

const propertiesSchema = Yup.object().shape({
  // name: Yup.string().required('Campo obrigatório'),
  // document: Yup.string().required('Campo obrigatório'),
  // number: Yup.number().required('Campo obrigatório').positive().integer(),
  // telephone: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().email().required('Campo obrigatório'),
})
interface props {
  data?: Properties
}
const EditOneProperties: React.FC<props> = ({data}) => {
  const intl = useIntl()
  const navigate = useNavigate()
  const animatedComponents = makeAnimated()
  const [project, setproject] = useState([])
  const [selectedFields, setSelectedFields] = useState<[]>()
  const [field, setFields] = useState([])
  const [selectedEnterprises, setSelectedEnterprises] = useState([])
  const [enterprises, setEnterprises] = useState([])
  const [loading, setLoading] = useState(false)
  //eslint-disable-next-line

  useEffect(() => {
    if (data) {
      getProperties(data)
    }
    return () => {
      console.log('error')
    }
    // eslint-disable-next-line
  }, [data])

  async function getProperties(data: any) {
    const Properties: IProperties = await data
    if (Properties.uuid) {
      formik.setFieldValue('uuid', Properties.uuid || '')
    }
    if (Properties.name) {
      formik.setFieldValue('name', Properties.name || '')
    }
    if (Properties.identifier) {
      formik.setFieldValue('identifier', Properties.identifier || '')
    }
    if (Properties.should_have_participation) {
      formik.setFieldValue('should_have_participation', Properties.should_have_participation || '')
    }
    if (Properties.project_id) {
      formik.setFieldValue('project_id', Properties.project_id || '')
    }
    if (Properties.indirect_profit_rate) {
      formik.setFieldValue('indirect_profit_rate', Properties.indirect_profit_rate || '')
    }
    if (Properties.address?.zip_code) {
      formik.setFieldValue('zip_code', Properties.address.zip_code || '')
      formik.setFieldValue('state', Properties.address.state || '')
      formik.setFieldValue('city', Properties.address.city || '')
      formik.setFieldValue('district', Properties.address.district || '')
      formik.setFieldValue('street_name', Properties.address.street_name || '')
      formik.setFieldValue('number', Properties.address.number || '')
      formik.setFieldValue('complement', Properties.address.complement || '')
    }

    if (Properties.enterprises) {
      setTimeout(() => {
        let enterprisesArray: any = []
        let enterprisesIdArray: any = []
        if (Properties.enterprises) {
          Properties.enterprises.map((field) => {
            enterprisesArray.push({
              code: field.id,
              name: `${field.name} - ${field.enterprise_type.description}`,
            })
            enterprisesIdArray.push(field.id)
            return {enterprisesArray, enterprisesIdArray}
          })
        }
        formik.setFieldValue('enterprise_id', enterprisesIdArray)
        setSelectedEnterprises(enterprisesArray)
      }, 5000)
    }
    if (Properties.fields) {
      setTimeout(() => {
        let fieldArray: any = []
        let fieldIdArray: any = []
        if (Properties.fields) {
          Properties.fields.map((field: any) => {
            fieldArray.push({
              code: field.id,
              name: `${field.name} - ${field.description} `,
            })
            fieldIdArray.push(field.id)
            return {fieldArray, fieldIdArray}
          })
        }
        formik.setFieldValue('field_id', fieldIdArray)
        setSelectedFields(fieldArray)
      }, 5000)
    }

    if (Properties.project) {
      setTimeout(() => {
        let projectArray: any = []
        if (Properties.project) {
          projectArray.push({
            value: Properties.project.id,
            label: `${Properties.project.code} - ${Properties.project.description} `,
          })
        }
        formik.setFieldValue('project_id', projectArray[0].value)
        setproject(projectArray)
      }, 5000)
    }
  }

  const formik = useFormik<IProperties>({
    initialValues,
    validationSchema: propertiesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.put(API_URL + '/sgt/v1/properties/' + values.uuid, values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PROPERTIES.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate(`/properties`)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PROPERTIES.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
      }
    },
  })

  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      let projects: any = []
      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results
        for (const element of Response) {
          const project: any = {
            value: element.id,
            label: `${element.code} - ${element.description} `,
          }
          projects.push(project)
        }
      }
      callback(projects)
    }, 1000)
  }
  const handleInputChangeProject = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    setproject(event)
    formik.setFieldValue('project_id', inputValue)
    return {inputValue}
  }

  function searchCEP(ev: any) {
    const {value} = ev.target

    const cep = value?.replace(/[^0-9]/g, '')

    if (cep?.length !== 8) {
      return
    }
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((data) => {
        formik.setFieldValue('zip_code', data.cep || '')
        formik.setFieldValue('state', data.uf || '')
        formik.setFieldValue('city', data.localidade || '')
        formik.setFieldValue('street_name', data.logradouro || '')
        formik.setFieldValue('district', data.bairro || '')
      })
  }

  const loadOptionsFields = () => {
    setTimeout(() => {
      getFields()
      let fields: any = []
      async function getFields() {
        const {data} = await axios.get(API_URL + '/v1/fields/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const field: any = {
              code: element.id,
              name: `${element.name} - ${element.description} `,
            }
            fields.push(field)
          }
        }
      }
      setFields(fields)
      return fields
    }, 1000)
  }

  const loadOptionsEnterprises = () => {
    setTimeout(() => {
      getEnterprises()
      let enterprises: any = []
      async function getEnterprises() {
        const {data} = await axios.get(API_URL + '/v1/enterprises/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const enterprise: any = {
              code: element.id,
              name: element.text,
            }
            enterprises.push(enterprise)
          }
        }
      }
      setEnterprises(enterprises)
      return enterprises
    }, 1000)
  }

  useEffect(() => {
    loadOptionsEnterprises()
    loadOptionsFields()
  }, [])

  return (
    <>
      <div className='row g-5 g-xl-8'>
        {/* begin::Col */}
        <div className='col-xxl-6 col-lg-12 '>
          <div className='card card-xl-stretch mb-xl-8'>
            {/* begin::Header */}
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-3 mb-1'>Dados da propriedade</span>
                </h3>
                <div className='card-toolbar'>
                  {/* begin::Menu */}
                  <button type='submit' className='btn btn-sm btn-light-primary' disabled={loading}>
                    {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                    {loading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
              {/* end::Header */}

              {/* begin::Body */}
              <div className='card-body pt-0 pb-8'>
                <div className='col-lg-12 mb-1'>
                  {/* INICIO LINHA 01*/}
                  <div className='row mb-1'>
                    <div className='col-lg-8'>
                      <Input3
                        key='name'
                        title={intl.formatMessage({id: 'PROPERTIES.NAME'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                        {...formik.getFieldProps('name')}
                      />
                    </div>
                    <div className='col-lg-4'>
                      <Input3
                        key='identifier'
                        title={intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                        {...formik.getFieldProps('identifier')}
                      />
                    </div>
                  </div>
                  {/* FIM LINHA 01*/}

                  {/* INICIO LINHA 02*/}
                  <div className='row mb-1'>
                    <div className='col-lg-6'>
                      <label className='col-form-label required fw-bold fs-6'>
                        {intl.formatMessage({id: 'PROPERTIES.PARTICIPATION'})}
                      </label>

                      <select
                        key='should_have_participation'
                        className='form-select form-select-solid ps-6'
                        data-kt-select2='true'
                        {...formik.getFieldProps('should_have_participation')}
                      >
                        <option></option>
                        <option value='yes'>{intl.formatMessage({id: 'COMMON.YES'})}</option>
                        <option value='no'>{intl.formatMessage({id: 'COMMON.NO'})}</option>
                        <option value='no_information'>
                          {intl.formatMessage({id: 'COMMON.NO_INFORMATION'})}
                        </option>
                      </select>
                    </div>
                    {/* INICIO Lucro ----------------------*/}
                    <div className='col-lg-6'>
                      <label className='col-lg-12 col-form-label fw-bold fs-6'>
                        <span className='required'>
                          {intl.formatMessage({id: 'INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE'})}
                        </span>
                      </label>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({
                          id: 'INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE',
                        })}
                        {...formik.getFieldProps('indirect_profit_rate')}
                      />
                      {formik.touched.indirect_profit_rate && formik.errors.indirect_profit_rate && (
                        <div className='fv-plugins-message-container text-danger'>
                          <div className='fv-help-block'>{formik.errors.indirect_profit_rate}</div>
                        </div>
                      )}
                    </div>
                    {/* FIM Lucro ------------------------------*/}
                  </div>
                  {/* FIM LINHA 02*/}

                  {/* INICIO LINHA 03*/}
                  <div className='row mb-1'>
                    <div className='col-lg-12'>
                      <label className='col-form-label required fw-bold fs-6'>
                        {intl.formatMessage({id: 'MENU.PROJECTS'})}{' '}
                      </label>

                      <AsyncSelect
                        key='project_id'
                        className='form-control form-control-lg form-control-solid p-1 pl-1'
                        styles={colourStyles}
                        components={animatedComponents}
                        cacheOptions
                        loadOptions={loadOptionsProjects}
                        value={project}
                        filterOption={(option, inputValue) =>
                          option.label
                            ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                            : false
                        }
                        defaultOptions
                        onChange={handleInputChangeProject}
                        placeholder={intl.formatMessage({
                          id: 'ENTERPRISES.INPUT_PROJECT_SELECT',
                        })}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                          },
                        })}
                      />
                    </div>
                  </div>
                  {/* FIM LINHA 03*/}

                  {/* INICIO LINHA 03*/}
                  <div className='row mb-1'>
                    <div className='col-lg-12'>
                      <label className='col-form-label required fw-bold fs-6'>
                        {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})}
                      </label>
                      <MultiSelect
                        key='field_id'
                        className='form-control form-control-lg form-control-solid p-1 pl-1 border border-white'
                        optionLabel='name'
                        value={selectedFields}
                        options={field}
                        style={{
                          fontFamily: 'Poppins',
                          fontSize: '1.15rem',
                          fontWeight: 'medium',
                          maxWidth: '981px',
                        }}
                        onChange={(e: any) => {
                          formik.setFieldValue(
                            'field_id',
                            e.value.map((v: any) => {
                              return v.code
                            })
                          )
                          setSelectedFields(e.value)
                        }}
                        placeholder={intl.formatMessage({
                          id: 'ENTERPRISES.INPUT_FIELDS_SELECT',
                        })}
                        filter
                        display='chip'
                      />
                    </div>
                  </div>
                  {/* FIM LINHA 03*/}

                  {/* INICIO LINHA 04*/}
                  <div className='row mb-1'>
                    <div className='col-lg-12'>
                      <label className='col-form-label required fw-bold fs-6'>
                        {intl.formatMessage({id: 'ENTERPRISES.INPUT_NAME'})}
                      </label>
                      <MultiSelect
                        className='form-control form-control-lg form-control-solid p-1 pl-1 border border-white'
                        optionLabel='name'
                        value={selectedEnterprises}
                        options={enterprises}
                        key='enterprise_id'
                        style={{
                          fontFamily: 'Poppins',
                          fontSize: '1.15rem',
                          fontWeight: 'medium',
                          maxWidth: '981px',
                        }}
                        onChange={(e: any) => {
                          formik.setFieldValue(
                            'enterprise_id',
                            e.value.map((v: any) => {
                              return v.code
                            })
                          )
                          setSelectedEnterprises(e.value)
                        }}
                        placeholder={intl.formatMessage({
                          id: 'ENTERPRISES.INPUT_FIELDS_SELECT',
                        })}
                        filter
                        display='chip'
                      />
                    </div>
                  </div>
                  {/* FIM LINHA 04*/}

                  {/* INICIO LINHA 05*/}
                  <div className='row mb-1'>
                    <div className='col-lg-6'>
                      <label className='col-form-label required fw-bold fs-6'>
                        {intl.formatMessage({id: 'COMMON.INPUT_ZIPCODE'})}
                      </label>

                      <InputMask
                        key='cep'
                        mask='99999-999'
                        type='text'
                        className='form-control form-control-lg form-control-solid p-1 ps-5'
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_ZIPCODE'})}
                        {...formik.getFieldProps('zip_code')}
                        onBlur={(e) => {
                          searchCEP(e)
                        }}
                      />
                    </div>
                    <div className='col-lg-6'>
                      <Input3
                        key='state'
                        title={intl.formatMessage({id: 'COMMON.INPUT_STATE'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_STATE'})}
                        {...formik.getFieldProps('state')}
                      />
                    </div>
                  </div>
                  {/* FIM LINHA 05*/}

                  {/* INICIO LINHA 06*/}
                  <div className='row mb-1'>
                    <div className='col-lg-6'>
                      <Input3
                        key='city'
                        title={intl.formatMessage({id: 'COMMON.INPUT_CITY'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_CITY'})}
                        {...formik.getFieldProps('city')}
                      />
                    </div>
                    <div className='col-lg-6'>
                      <Input3
                        key='district'
                        title={intl.formatMessage({id: 'COMMON.INPUT_DISTRICT'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_DISTRICT'})}
                        {...formik.getFieldProps('district')}
                      />
                    </div>
                  </div>
                  {/* FIM LINHA 06*/}

                  {/* INICIO LINHA 07*/}
                  <div className='row mb-1'>
                    <div className='col-lg-12'>
                      <Input3
                        key='street_name'
                        title={intl.formatMessage({id: 'COMMON.INPUT_ADDRESS'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_ADDRESS'})}
                        {...formik.getFieldProps('street_name')}
                      />
                    </div>
                  </div>
                  {/* FIM LINHA 07*/}

                  {/* INICIO LINHA 08*/}
                  <div className='row mb-1'>
                    <div className='col-lg-6'>
                      <Input3
                        key='number'
                        title={intl.formatMessage({id: 'COMMON.INPUT_NUMBER'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_NUMBER'})}
                        {...formik.getFieldProps('number')}
                        onChange={(e) => {
                          formik.setFieldValue('number', e.target.value)
                        }}
                      />
                    </div>
                    <div className='col-lg-6'>
                      <Input3
                        key='complement'
                        title={intl.formatMessage({id: 'COMMON.INPUT_COMPLEMENT'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_COMPLEMENT'})}
                        {...formik.getFieldProps('complement')}
                        onChange={(e) => {
                          formik.setFieldValue('complement', e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  {/* FIM LINHA 08*/}
                </div>
              </div>
            </form>
          </div>
          {/* end::Col */}
        </div>

        {/* begin::Col */}
        <div className='col-xxl-6 col-lg-12'>
          <PropertiesParticipationsList data={data} />
          <IndemnityItemPage />
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

export {EditOneProperties}
